/**
 * The story piece's standard look (the prototype's About: Our story).
 * Draws the behavior half's state; holds no rule. Draws nothing without a story.
 */
import { useId } from 'react';

import { partsOf, pieceRoot, usePlaced } from '../../contract/runtime';
import shared from '../../styles/shared.module.css';
import type { StoryRuntime } from './useStory';
import css from './Story.module.css';
import { contract } from './contract';

const part = partsOf(contract);

export function StoryView({ state, options }: StoryRuntime) {
  // Placed on a custom page (web-studio-sites D4): no band, no frame, no fixed anchor.
  const placed = usePlaced();
  const placedTitle = useId();
  if (state.paragraphs.length === 0) return null;
  const titleId = placed ? placedTitle : 'storyTitle';
  return (
    <section
      className={placed ? undefined : shared.sec}
      id={placed ? undefined : 'about'}
      aria-labelledby={options.heading ? titleId : undefined}
      aria-label={options.heading ? undefined : 'About the studio'}
      {...pieceRoot(contract)}
      {...part('section')}
    >
      <div className={placed ? undefined : shared.wrap}>
        <div className={css.story}>
          {(options.eyebrow || options.heading) && (
            <div className={css.left}>
              {options.eyebrow && (
                <div className={shared.eyebrow} {...part('eyebrow')}>
                  {options.eyebrow}
                </div>
              )}
              {options.heading && (
                <h2 className={`${shared.h2} ${css.heading}`} id={titleId} {...part('heading')}>
                  {options.heading}
                </h2>
              )}
            </div>
          )}
          <div className={css.right}>
            <div className={`${shared.prose} ${css.prose}`} {...part('text')}>
              {state.paragraphs.map((p, i) => (
                <p key={i} {...part('paragraph')}>
                  {p}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
